import PropTypes from 'prop-types';

const radarDataTypes = PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
})).isRequired;

export default radarDataTypes;
